<template>
  <div class="mf-card clickable-card" @click="handleClick(log)">
    <v-row no-gutters>
      <v-col cols="10">
        <v-row class="px-3 py-1">
          <v-col cols="3" class="pb-1 pt-0 info-text">Usuário:</v-col>
          <v-col cols="9" class="pb-1 pt-0 info-text info-text__bold">{{ log.user.login }}</v-col>
          <v-col cols="3" class="pb-1 pt-0 info-text">Data e hora:</v-col>
          <v-col cols="9" class="pb-1 pt-0 info-text info-text__bold">{{
            log.created_at | date({ fmtIn: 'yyyy-MM-dd HH:mm:ss', fmtOut: 'dd/MM/yyyy HH:mm:ss' })
          }}</v-col>
        </v-row>
      </v-col>
      <v-col cols="2" class="d-flex justify-center align-center" style="background-color: #e0e0e0">Ver detalhes</v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'LogSummaryCard',
  props: {
    log: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClick(log) {
      this.$emit('select-log', log)
    },
  },
}
</script>

<style lang="scss" scoped>
.clickable-card {
  width: 100%;
  display: block;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 6px 0px;
}

.clickable-card:hover {
  background-color: #f0f0f0;
}
</style>
